import React, { useEffect } from 'react';
import { urlGenerator } from '../../../../utilities/order/urlGenerator';
import { fieldToBody, fieldToLabel } from './fieldNameToThings';
import { TransactionValidationSchemaGenerator } from './TransactionValidationSchema';
import { useHistory } from 'react-router-dom';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { routeNames } from 'utilities/order/formConfig';
import { useUpdateOrderTimberHook } from 'API/order/useUpdateOrderHook';
import {
  EditSingleFieldController
} from '../../../../ui-toolkit/orders/components/EditSingleField/EditSingleFieldController';
import {
  eEditSingleFieldInputType
} from '../../../../ui-toolkit/orders/components/EditSingleField/eEditSingleFieldInputType';

interface IEditTransactionContainerProps {
  field: routeNames;
  onClose?: () => void;
  loadOrder?: () => Promise<void>;
}

export const EditTransactionContainer: React.FC<IEditTransactionContainerProps> = ({
  field,
  loadOrder = () => {},
  ...props
}) => {
  const { data: order } = useSelectCurrentOrder();
  const history = useHistory();
  // When they send in an onClose, they are also handling the document title.
  let onClose = props.onClose || (() => history.push(urlGenerator.urlFor.orderStatus(order.transaction.id!)));
  const { action: doOrderUpdate } = useUpdateOrderTimberHook();

  useEffect(() => {
    if (props.onClose === undefined) {
      document.title = `Order Overview: ${fieldToLabel[field]} - Spruce`;
    }
  }, [field, props.onClose]);

  const doSubmit = async (value: any) => {
    await doOrderUpdate(order, { [fieldToBody[field]]: value });
    return { message: '' };
  };

  return (
    <EditSingleFieldController
      displayLabel={fieldToLabel[field]}
      actions={{ onClose, doSubmit }}
      inputType={eEditSingleFieldInputType.Currency}
      value={order.transaction[field]}
      validationSchema={TransactionValidationSchemaGenerator(order.transaction.transaction_category, field)}
    />
  );
};
